import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import { OTB_DEFAULT_VALUE } from 'frontend-utils/utils/constants/constant-values';

type FormatParameters = Parameters<IntlService['formatNumber']>;

interface FormatOtbValueSignature {
  Args: {
    Named?: FormatParameters[1];
    Positional: [FormatParameters[0]];
  };
  Return: string;
}

export default class FormatOtbValueHelper extends Helper<FormatOtbValueSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  compute(
    [value]: FormatOtbValueSignature['Args']['Positional'],
    options: FormatOtbValueSignature['Args']['Named'],
  ) {
    if (value === undefined || value === null) {
      return this.intl.t('general.not_available_short');
    }

    if (value === OTB_DEFAULT_VALUE) {
      return this.intl.t('general.not_available_short');
    }

    return this.intl.formatNumber(value, options);
  }
}
